import i18n from '@/i18n';

export const SUPPLIER_STEP_1 = 0;
export const SUPPLIER_STEP_2 = 1;
export const SUPPLIER_STEP_3 = 2;
export const SUPPLIER_STEP_4 = 3;

const steps = {
  [SUPPLIER_STEP_1]: {
    component: () => import(/* webpackChunkName: "venue" */ '@/views/platform/venue/suppliers/new/NewSupplierInfo.vue'),
    title: `Create New ${i18n.t('global.distributor')}`,
    pageTitle: `Create new ${i18n.t('global.distributor')}`,
    pageInfo: `Provide ${i18n.t('global.distributor')} details below *denotes mandatory fields.`,
    nextCta: 'Next Step',
  },
  [SUPPLIER_STEP_2]: {
    component: () => import(/* webpackChunkName: "venue" */ '@/views/platform/venue/suppliers/new/NewSupplierUsers.vue'),
    title: `Create New ${i18n.t('global.distributor')}`,
    pageTitle: 'Now add your contacts',
    pageInfo: 'Add contacts that will receive notifications about your orders. Setting a primary contact is mandatory since that contact is going to be treated as an owner.',
    nextCta: 'Next Step',
  },
  [SUPPLIER_STEP_3]: {
    component: () => import(/* webpackChunkName: "venue" */ '@/views/platform/venue/suppliers/new/NewSupplierProducts.vue'),
    title: `Create New ${i18n.t('global.distributor')}`,
    pageTitle: 'Now add products',
    pageInfo: `Add products that will be in this ${i18n.t('global.distributor')}’s inventory`,
    nextCta: 'Go to Overview',
  },
  [SUPPLIER_STEP_4]: {
    component: () => import(/* webpackChunkName: "venue" */ '@/views/platform/venue/suppliers/new/NewSupplierOverview.vue'),
    title: `Create New ${i18n.t('global.distributor')}`,
    pageTitle: 'Overview',
    pageInfo: `Before you complete adding a new ${i18n.t('global.distributor')}, check the information below to make sure you’ve entered everything correctly.`,
    nextCta: 'Finish',
  },
};

export default steps;
